import SentimentEditor from './SentimentEditor'
export default SentimentEditor



/** WEBPACK FOOTER **
 ** ./src/Editors/SentimentEditor/index.js
 **/